<template>
  <header
    class="
      flex
      items-center
      justify-between
      px-6
      py-2
      bg-white
      border-b-4 border-indigo-600
    "
  >
    <div class="flex items-center">
      
    </div>

    <div class="flex items-center">
      <div class="relative">
        <button
          class="
            relative
            z-10
            block
            w-8
            h-8
            overflow-hidden
            rounded-full
            shadow
            focus:outline-none
            avatar-user-link
          "
        >
          
          <img class="object-cover w-full h-full" src="../assets/img/icon-app.png" alt="Your avatar" />
        </button>

        <div
          class="
            absolute
            right-0
            z-20
            w-48
            py-1
            mt-2
            bg-white
            rounded-lg
            shadow-xl
            logout-dropdown
            hidden
          "
        >
            <div
              class="
                flex
                px-4
                py-2
                rounded-md
                text-sm text-gray-700
                hover:bg-indigo-600 hover:text-white
                cursor-pointer
              "
              @click="logout"
            >
              Log out
            </div>
          </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { useAuthStore } from "@/stores/auth/authStore";
import { useRouter } from "vue-router";
import { ref, onMounted, provide } from 'vue';

const authStore = useAuthStore();
const router = useRouter();

const logout = () => {
  console.error('logout Header')
  authStore.logout();
  localStorage.removeItem('token');
  router.push('/');
};




</script>
<style scoped>

header{
  border-bottom: 4px solid #0A3382;
}
.logout-dropdown{
  margin-top: -5px;
}
.logout-dropdown:hover,
.avatar-user-link:hover + .logout-dropdown{
  display: block;
}
</style>


